module.exports = __webpack_public_path__ + "static/img/4019.b904987.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4019.png
// module id = 726
// module chunks = 0 1 12